module.exports = __webpack_public_path__ + "img/fig04.cbc0d1bd.jpg";